var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'trust-score',
    _vm.scoreThreshold,
    _vm.size,
    { neutral: _vm.neutral, 'dark-mode': _vm.darkMode },
  ]},[_c('span',[_vm._v(_vm._s(_vm.score))]),(_vm.showStar)?_c('span',{staticClass:"star"},[_c('font-awesome-icon',{attrs:{"icon":"star"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }